import React from "react";
import axios from "axios";
import APIURL from "../../../Main/apiurl";

const create_service_category = async (category) => {
  try {
    const data = {
      name: category?.name,
      description: category?.description,
      status: category?.status,
      branch: category?.branch,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/create-service-category`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const update_service_category = async (category) => {
  try {
    const data = {
      id: category?.id,
      name: category?.name,
      description: category?.description,
      status: category?.status,
      branch: category?.branch,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/update-service-category`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_service_category = async (category) => {
  try {
    const data = {
      id: category?.id,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-service-category`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_all_service_categories = async (category) => {
  try {
    const data = {
      search: category?.search,
      status: category?.status,
      page: category?.page,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-all-service-categories`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_service_category_log = async (category) => {
  try {
    const data = {
      search: category?.search,
      sort: category?.sort,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-all-service-category-log`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

const get_all_service_category_logs = async (category) => {
  try {
    const data = {
      search: category?.search,
      sort: category?.sort,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(
      `${APIURL}/get-all-service-category-logs`,
      data,
      config
    );
    return response?.data;
  } catch (error) {
    return error;
  }
};

export {
  create_service_category,
  update_service_category,
  get_service_category,
  get_all_service_categories,
  get_service_category_log,
  get_all_service_category_logs,
};
